/**
 * ReportService
 * --------------------------------------------
 * --------------------------------------------
 *
 * Controlador que tiene los endpoints de Reporte.
 *
 * Endpoints:
 * ------------------
 * 1.  GET    ->  {ENDPOINT_PATH}{idCluster}/alarms
 * 2.  POST    ->  {ENDPOINT_PATH}{idCluster}/solarhubs/{idSolarHub}/alarms
 * 3.  DELETE    ->  {ENDPOINT_PATH}{idCluster}/solarhubs/{idSolarHub}/alarms/{idAlarm}
 * 4.  GET    ->  {ENDPOINT_PATH_REPORT}{uuid}/{idReport}
 *
 */
import axios from "axios";
import { getAuthToken } from "@/utils/AuthService.js";

const ENDPOINT_PATH = "http://urbanbrain.siarq.com:8080/cluster/";
const ENDPOINT_PATH_REPORT = "http://urbanbrain.siarq.com:8080/report/";

/** 1. Endpoint getReportData
 * ------------------------------------------------------------------------------
 * Obtiene todos los clusters del usuario.
 *
 * url: {ENDPOINT_PATH}{idCluster}/solarhubs/{idSolarHub}/schedules
 *
 * method: GET
 *
 * type: JSON
 *
 * @param idCluster
 * @param idSolarHub
 */
export function getReportData(idCluster, idSolarHub) {
  return new Promise(async (resolve, reject) => {
    try {
      let report = await axios({
        url: `${ENDPOINT_PATH}${idCluster}/solarhubs/${idSolarHub}/schedules`,
        method: "GET",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      resolve(report.data);
    } catch (err) {
      console.error("Caught an error during report:", err);
      reject(err);
    }
  });
}
/** 2. Endpoint createProgramReport
 * ------------------------------------------------------------------------------
 * Crea un reporte programado.
 *
 * url: {{ENDPOINT_PATH}{idCluster}/solarhubs/{solarHub.id}/schedules
 *
 * method: POST
 *
 * type: JSON
 *
 * @param report
 * @param idCluster
 * @param solarHub
 *
 */
export function createProgramReport(report, idCluster, solarHub) {
  return new Promise(async (resolve, reject) => {
    var sensorsIds = [];
    report.sensors.forEach((element) => {
      solarHub.sensors.forEach((item) => {
        if (item.name == element.name) {
          sensorsIds.push({ id: item.id });
        }
      });
    });
    try {
      let res = await axios({
        url: `${ENDPOINT_PATH}${idCluster}/solarhubs/${solarHub.id}/schedules`,
        method: "POST",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
        data: {
          frequency: report.frequency,
          endDate: report.end_period,
          active: true,
          sensors: sensorsIds,
          type: (report.type = report.type === "L1" ? 1 : 2),
        },
      });
      resolve(res.data);
    } catch (err) {
      console.error("Caught an error during login:", err);
      reject(err);
    }
  });
}
/** 3. Endpoint delReport
 * ------------------------------------------------------------------------------
 * Elimina un reporte programado.
 *
 * url: {{ENDPOINT_PATH}{idCluster}/solarhubs/{idSolarHub}/schedules/{idReport}
 *
 * method: DELETE
 *
 * type: JSON
 *
 * @param idCluster
 * @param solarHub
 * @param idReport
 *
 */
export function delReport(idCluster, idSolarHub, idReport) {
  return new Promise(async (resolve, reject) => {
    try {
      let report = await axios({
        url: `${ENDPOINT_PATH}${idCluster}/solarhubs/${idSolarHub}/schedules/${idReport}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      resolve(report.data);
    } catch (err) {
      console.error("Caught an error during report:", err);
      reject(err);
    }
  });
}
/** 4. Endpoint getReportByUuid
 * ------------------------------------------------------------------------------
 * Obtiene un reporte mediante una url con uuid y el id del reporte.
 *
 * url: {ENDPOINT_PATH_REPORT}{uuid}/{idReport}
 *
 * method: GET
 *
 * type: JSON
 *
 * @param uuid
 * @param idReport
 *
 */
export function getReportByUuid(uuid, idReport) {
  return new Promise(async (resolve, reject) => {
    try {
      let report = await axios({
        url: `${ENDPOINT_PATH_REPORT}${uuid}/${idReport}`,
        method: "GET",
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      resolve(report.data);
    } catch (err) {
      console.error("Caught an error during report:", err);
      reject(err);
    }
  });
}
